<div class="menu-wrapper" [class.open]="menuOpen">
  <ul class="main-menu">
    <li *ngFor="let menuItem of menuItems" class="nav-item" [ngClass]="{ 'dropdown': menuItem.type === 'sub' }">

      <!-- First-level link -->
      <a *ngIf="menuItem.type === 'link'" [routerLink]="menuItem.routerLink" routerLinkActive="active-menu">
        {{ menuItem.title }}
      </a>

      <!-- First-level dropdown -->
      <div *ngIf="menuItem.type === 'sub'" class="dropdown">
        <a 
          [routerLink]="menuItem.routerLink"
          routerLinkActive="active-menu"
          class="dropdown-toggle"
          (click)="onDropdownClick(menuItem, $event)">
          {{ menuItem.title }}
        </a>
        <ul class="dropdown-menu" [class.show]="menuItem.open">
          <li *ngFor="let child of menuItem.children" [ngClass]="{ 'dropdown-sub': child.children?.length }">

            <!-- If child has sub-children -->
            <div *ngIf="child.children?.length" class="nested-dropdown">
              <a (click)="toggleNestedDropdown(child, $event)">
                {{ child.title }}
              </a>
              <ul class="dropdown-menu nested" [class.show]="child.open">
                <li *ngFor="let subChild of child.children">
                  <a [routerLink]="subChild.routerLink" [fragment]="subChild.fragment">
                    {{ subChild.title }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- If no sub-children -->
            <a *ngIf="!child.children?.length" [routerLink]="child.routerLink" [fragment]="child.fragment">
              {{ child.title }}
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</div>

<div class="burger-icon" (click)="menuOpen = !menuOpen">
  <span></span>
  <span></span>
  <span></span>
</div>
